import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="false"
      sx={{
        backgroundColor: 'backgroundPrimary.main',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: {
            xs: '180px',
            sm: '200px',
            lg: '300px',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: '1.9rem',
              sm: '2.5rem',
              lg: '5.5rem',
            },
            color: {
              lg: 'primary.main',
            },
          }}
        >
          404
        </Typography>

        <Typography
          sx={{
            fontSize: {
              xs: '1.9rem',
              sm: '2.5rem',
              lg: '3.5rem',
            },
            color: {
              lg: 'textPrimary.main',
            },
          }}
        >
          Page Not Found
        </Typography>

        <Button variant="contained" onClick={() => navigate('/')}>
          Go Home
        </Button>
      </Box>
    </Container>
  );
};

export default PageNotFound;
